import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class ServiceStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.services = [];
    this.trending = [];
  }

  handleLoadSuccess(services) {
    this.services = services;
    this.emitChange();
  }

  handleMoreTrendingList(data) {
    this.trending = data;
    this.emitChange();
  }

  handleMOre(services) {
    for (var obj in this.services) {
      if (this.services[obj].name == services.name) {
        this.services[obj].entitiesList = services.entitiesList;
      }
    }
    this.emitChange();
  }

  get() {
    return {
      service: this.services,
      trending: this.trending
    };
  }

  dehydrate() {
    return {
      service: this.services,
      trending: this.trending
    };
  }

  rehydrate(state) {
    this.services = state.services;
  }
}

ServiceStore.storeName = 'ServiceStore';
ServiceStore.handlers = {
  [Actions.LOAD_SERVICE_SUCCESS]: 'handleLoadSuccess',
  [Actions.LOAD_SERVICEMORE_SUCCESS]: 'handleMOre',
  [Actions.LOAD_CATEGTRENDING_SUCCESS]: 'handleMoreTrendingList',
};

export default ServiceStore;


// WEBPACK FOOTER //
// ./src/stores/ServiceStore.js